import { RootSchema } from "../../../redux/reducers";
import { AnalyticsEvent } from "../types";
import { mapStaticMutation } from "./helpers";

export const mapSecurityAnalyticsEvents = (previousState: RootSchema, currentState: RootSchema): AnalyticsEvent[] => [
  ...mapStaticMutation(previousState.securityConfiguration?.updatePinAuth, currentState.securityConfiguration?.updatePinAuth, {
    getSuccessEventName: (state) => ((state as any)?.IsPosted ? "security_pin_configured_successfully" : "security_pin_disabled"),
    errorEventName: "security_pin_got_error"
  }),
  ...mapStaticMutation(previousState.securityConfiguration?.updateRiskAuthSettings, currentState.securityConfiguration?.updateRiskAuthSettings, {
    getSuccessEventName: (state) => ((state as any)?.RiskFactors ? "security_rba_configured_successfully" : "security_rba_deleted"),
    errorEventName: "security_rba_got_error"
  }),
  ...mapStaticMutation(previousState.securityConfiguration?.updateCaptchaSettingsData, currentState.securityConfiguration?.updateCaptchaSettingsData, {
    getSuccessEventName: (state) => ((state as any)?.Data?.IsEnabled === false ? "security_bot_protection_disabled" : "security_bot_protection_configured_successfully"),
    errorEventName: "security_bot_protection_got_error",
    trackedEventNames: ["security_bot_protection_configured_successfully", "security_bot_protection_disabled", "security_bot_protection_got_error"]
  }),
  ...mapStaticMutation(previousState.securityConfiguration?.updateAppBasicSettings, currentState.securityConfiguration?.updateAppBasicSettings, {
    errorEventName: "security_brute_force_got_error",
    trackedEventNames: ["security_brute_force_configured_successfully", "security_brute_force_disabled", "security_brute_force_got_error"]
  }),
  ...mapStaticMutation(previousState.securityConfiguration?.postBreachedPassword, currentState.securityConfiguration?.postBreachedPassword, {
    getSuccessEventName: (state) => ((state as any)?.data?.EnableBreachedPasswordValidation === false ? "security_breached_password_disabled" : "security_breached_password_configured_successfully"),
    errorEventName: "security_breached_password_got_error",
    trackedEventNames: ["security_breached_password_configured_successfully", "security_breached_password_disabled", "security_breached_password_got_error"]
  }),
  ...mapStaticMutation(previousState.securityConfiguration?.passwordPolicy, currentState.securityConfiguration?.passwordPolicy, {
    successEventName: "security_password_policy_saved",
    errorEventName: "security_password_policy_got_error",
    trackedEventNames: ["security_password_policy_saved", "security_password_policy_reset", "security_password_policy_got_error"]
  }),
  ...mapStaticMutation(previousState.domainAccessManagement, currentState.domainAccessManagement, {
    getSuccessEventName: (state) => ((state as any)?.Data?.IsEnabled ? "security_domain_access_configured_successfully" : "security_domain_access_disabled"),
    errorEventName: "security_domain_access_got_error"
  }),
  // IP Access Management (/security/attack-protection/ip-access-management). The concrete
  // success event is chosen by the dispatching section's trackingMeta — one slice serves two
  // independently-toggled scopes, so state alone cannot say which one was configured/disabled;
  // which scope it was travels as the `api_type` property ("manage" or "auth").
  // Shares the security_ip_access_* family with the registration-restriction entry below, which
  // sends no `api_type` — that property is what separates the two in reporting.
  ...mapStaticMutation(previousState.ipAccessManagement, currentState.ipAccessManagement, {
    errorEventName: "security_ip_access_got_error",
    trackedEventNames: ["security_ip_access_configured_successfully", "security_ip_access_disabled", "security_ip_access_got_error"]
  }),
  ...mapStaticMutation(previousState.domainAccessRestriction, currentState.domainAccessRestriction, {
    getSuccessEventName: (state) => ((state as any)?.Data?.RegistrationRestrictionType ? "security_ip_access_configured_successfully" : "security_ip_access_disabled"),
    errorEventName: "security_ip_access_got_error"
  }),
  ...mapStaticMutation(previousState.securityConfiguration?.securityquestions, currentState.securityConfiguration?.securityquestions, {
    successEventName: "security_questions_configured_successfully",
    errorEventName: "security_questions_got_error",
    trackedEventNames: ["security_questions_configured_successfully", "security_questions_deleted", "security_questions_got_error"]
  }),
  ...mapStaticMutation(previousState.securityConfiguration?.updateForceLogoutData, currentState.securityConfiguration?.updateForceLogoutData, {
    successEventName: "security_session_management_saved",
    errorEventName: "security_session_management_got_error",
    trackedEventNames: ["security_session_management_saved", "security_session_management_reset", "security_session_management_got_error"]
  }),
  ...mapStaticMutation(previousState.securityConfiguration?.updateRemeberMeData, currentState.securityConfiguration?.updateRemeberMeData, {
    successEventName: "security_session_management_saved",
    errorEventName: "security_session_management_got_error",
    trackedEventNames: ["security_session_management_saved", "security_session_management_reset", "security_session_management_got_error"]
  }),
  ...mapStaticMutation(previousState.securityConfiguration?.updateSessionLimitData, currentState.securityConfiguration?.updateSessionLimitData, {
    successEventName: "security_session_management_saved",
    errorEventName: "security_session_management_got_error",
    trackedEventNames: ["security_session_management_saved", "security_session_management_reset", "security_session_management_got_error"]
  }),
  ...mapStaticMutation(previousState.dataConfiguration?.privacyPolicy, currentState.dataConfiguration?.privacyPolicy, {
    trackedEventNames: [
      "security_privacy_versioning_saved",
      "security_privacy_versioning_got_error",
      "security_consent_form_created",
      "security_consent_form_updated",
      "security_consent_form_deleted",
      "security_consent_form_published",
      "security_consent_form_got_error",
      "security_age_verification_saved",
      "security_age_verification_reset",
      "security_age_verification_got_error"
    ]
  })
];
